import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globals } from '@aiwyn/config';
import { Observable } from 'rxjs';
import { CLIENT_API_V1_BASE_PATH } from '../api/models/base-paths.model';

export interface MintResponse {
  /**
   * Signed Zendesk Messaging `loginUser` JWT for the current verified session,
   * or `null` when the session is not eligible for an authenticated identity
   * (e.g. a firm user, or the server isn't configured) — in which case the
   * widget stays anonymous.
   */
  jwt: string | null;
}

/**
 * Calls the artengine mint endpoint (AIW-1319) to obtain a Zendesk Messaging JWT
 * for the authenticated client-portal user.
 *
 * The route moved postgraphile -> artengine (anduin #6981/#6982); postgraphile no
 * longer serves it at all. It now sits on the same host and under the same secure
 * client prefix as every other artengine call, so it is addressed the same way —
 * `artUrl` + `CLIENT_API_V1_BASE_PATH` — and picks up the `Bearer`/`Tenant` pair
 * that artengine's `ClientTokenHandlerInterceptor` requires from the same
 * interceptor rule that already covers those calls.
 */
@Injectable({ providedIn: 'root' })
export class ChatbotApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly globals: Globals,
  ) {}

  mintMessagingJwt(): Observable<MintResponse> {
    return this.http.post<MintResponse>(`${this.globals.artUrl}${CLIENT_API_V1_BASE_PATH}/chatbot/mint`, {});
  }
}
